export default __webpack_public_path__ + "locales/sk/FillPDFDialog.json?hash=04c848ec44c1d92592e4ce4e18bb5153";